import React from 'react';

const VerseNavigation = ({ selectedVerse, currentVerses, onVerseChange, onNext, onPrev }) => {
  return (
    <div style={{ width: '20%', borderRight: '1px solid #ccc', paddingRight: '10px' }}>
      <h3>Page {currentVerses[0]?.page_number || 'N/A'}</h3>
      <ul style={{ listStyleType: 'none', padding: 0 }}>
        {currentVerses.map(verse => (
          <li 
            key={verse.verse_number} 
            onClick={() => onVerseChange(verse.verse_number)} 
            style={{ cursor: 'pointer', padding: '5px', background: verse.verse_number === selectedVerse ? '#ddd' : 'transparent' }}
          >
            Verse {verse.verse_number}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default VerseNavigation;
